import { useAuth0, withAuthenticationRequired } from "@auth0/auth0-react";
import styles from "./logs.module.css";
import Loader from "../../../components/Loader";
import Footer from "../../../components/Footer";
import { Home } from "react-feather";
import { Typography } from "@mui/material";
import { Helmet } from "react-helmet";
import LogFilter from "./components/LogFilter";
import LogList from "./components/LogList";
import { useState, useEffect } from "react";
import axios from 'axios';
import { TableLoaderSmall } from "../../../components/LoaderC";
import dayjs from "dayjs";

const Logs = () => {
    const { getAccessTokenSilently } = useAuth0();
    const [contentLoading, setContentLoading] = useState(true);
    const [allData, setAllData] = useState([]);
    const [filterData, setFilterData] = useState({ searchKey: "", type: "", campaign: "", submitted: null, page: 0, perPage: 8 });
    const [totalCount, setTotalCount] = useState(0);
    const [campaignList, setCampaignList] = useState([]);

    useEffect(() => {
        if (localStorage.getItem("emailAnalyticsCampaign")) {
            let filtercampaignId = localStorage.getItem("emailAnalyticsCampaign");

            setFilterData((prev) => {
                return { ...prev, campaign: parseInt(filtercampaignId) };
            });
        }
    }, []);

    useEffect(() => {
        const getLogList = async () => {
            const queryParams = new URLSearchParams();
            queryParams.append("page", filterData?.page);
            queryParams.append("perPage", filterData?.perPage);
            queryParams.append("searchKey", filterData?.searchKey);
            queryParams.append("type", filterData?.type);
            queryParams.append("campaign", filterData?.campaign);

            if (localStorage.getItem("emailAnalyticsCampaign")) {
                let filtercampaignId = localStorage.getItem("emailAnalyticsCampaign");
                localStorage.removeItem("emailAnalyticsCampaign");
                queryParams.append("campaign", parseInt(filtercampaignId));
            }


            if (filterData?.submitted && Array.isArray(filterData?.submitted) && filterData?.submitted.length === 2) {
                const start = dayjs(filterData?.submitted[0]).format("YYYY-MM-DD");
                const end = dayjs(filterData?.submitted[1]).format("YYYY-MM-DD");
                queryParams.append("submitted", `${start},${end}`);
            } else {
                queryParams.append("submitted", "");
            }

            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-campaign-logs?" + queryParams.toString(), {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            }).then((response) => {
                setContentLoading(false);
                setAllData(response.data.data);
                setTotalCount(response.data.total);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        getLogList();
    }, [getAccessTokenSilently, filterData]);

    useEffect(() => {
        const getCampaignList = async () => {
            const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });

            axios(process.env.REACT_APP_USER_API_URL + "v1/campaign/email-templates", {
                headers: {
                    Authorization: `Bearer ${token}`,
                },
            }).then((response) => {
                setCampaignList(response.data.data);
            }).catch(() => {
                setContentLoading(false);
            });
        }

        getCampaignList();
    }, [getAccessTokenSilently]);

    return (<>
        <Helmet title="Email analytics" />

        <div className={`${styles.pageTitleWrap}`}>
            <Typography display="inline" className={`${styles.pageTitle}`}>Email Analytics</Typography>
            <nav aria-label="breadcrumb">
                <ol className={`${styles.breadcrumb}`}>
                    <li className={`${styles.breadcrumbItem}`}><span><Home /></span> Email Champaign</li>
                    <li className={`${styles.breadcrumbItem} ${styles.active}`}>Email Analytics</li>
                </ol>
            </nav>
        </div>

        <div className={`${styles.BodyCon}`}>
            <div className={`${styles.mainCardDiv}`}>
                <div className={`${styles.mainCard}`}>
                    {contentLoading && <div className="Loader TableLoader"><TableLoaderSmall /></div>}

                    {!contentLoading && <div className="control-pane">
                        <div className={`${styles.Row}`}>

                            <LogFilter filterData={filterData} setFilterData={setFilterData.bind(this)} campaignList={campaignList} />

                            <div className={`${styles.LogMaiSec}`}>
                                <LogList filteredData={allData} totalCount={totalCount} filterData={filterData} setFilterData={setFilterData.bind(this)} />
                            </div>

                        </div>
                    </div>}
                </div>
            </div>
        </div>

        <Footer />
    </>)
}

export default withAuthenticationRequired(Logs, {
    onRedirecting: () => <Loader />,
});